import { createContext, useContext, useEffect, useState } from "react";
import { initializeApp } from "firebase/app";
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, onAuthStateChanged, signOut } from "firebase/auth";
import { getFirestore, doc, getDoc, getDocs, addDoc, collection, deleteDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";

const FirebaseContext = createContext(null);

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: "skillshareindia-admin.firebaseapp.com",
    projectId: "skillshareindia-admin",
    storageBucket: "skillshareindia-admin.appspot.com",
    messagingSenderId: "343570437474",
    appId: "1:343570437474:web:f631609587cc30b6b0c83b"
};

const FirebaseApp = initializeApp(firebaseConfig);
const FirebaseAuth = getAuth(FirebaseApp);
const FireStore = getFirestore(FirebaseApp);
const storage = getStorage(FirebaseApp);

export const useFirebase = () => useContext(FirebaseContext);

export const FirebaseProvider = (props) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const authorizedEmail = "skillshareindiaworktogrow@gmail.com"; // Replace with the single email you want to allow

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(FirebaseAuth, (user) => {
            if (user) {
                setUser(user);
                setIsLoggedIn(true);
            } else {
                setUser(null);
                setIsLoggedIn(false);
            }
            setLoading(false); // Set loading to false once the auth state is determined
        });
    
        return () => unsubscribe();
    }, []);
    

    const signUpUserWithEmail = async (email, pass) => {
        try {
            await createUserWithEmailAndPassword(FirebaseAuth, email, pass);
        } catch (error) {
            console.error("Error in signUpUserWithEmail: ", error);
        }
    };

    const signInUserWithEmail = async (email, pass) => {
        if (email !== authorizedEmail) {
            console.error("Unauthorized email attempt: ", email);
            throw new Error("You are not authorized to log in.");
        }
        try {
            await signInWithEmailAndPassword(FirebaseAuth, email, pass);
            console.log("Success in signing user");
        } catch (error) {
            console.error("Error in signInUserWithEmail: ", error);
        }
    };

    const logout = async () => {
        try {
            await signOut(FirebaseAuth);
            setIsLoggedIn(false);
            console.log("Signout success");
        } catch (error) {
            console.error("Error in logout: ", error);
        }
    };

    const setArticles = async (name, classs, school, rank, studID, destPic) => {
        try {
            const imageRef = ref(storage, `uploads/${school}/${name}/${Date.now()}-${destPic ? destPic.name : 'no-image'}`);
            const uploadStatePic = await uploadBytes(imageRef, destPic);
            
            return await addDoc(collection(FireStore, `school`), {
                name,
                classs,
                school,
                rank,
                studID,
                imageURL: uploadStatePic.ref.fullPath,
                writtenOnDate: new Date().toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                }),
            });
        } catch (error) {
            console.error("Error in setArticles: ", error);
        }
    };

    const deleteStudent = async (studentId, imageUrl) => {
        try {
            // Delete the student document from Firestore
            const studentRef = doc(FireStore, `school`, studentId);
            await deleteDoc(studentRef);
            console.log("Student data deleted successfully.");
    
            // Delete the image from Firebase Storage if it exists
            if (imageUrl) {
                const imageRef = ref(storage, imageUrl);
                await deleteObject(imageRef);
                console.log("Student image deleted successfully.");
            }
        } catch (error) {
            console.error("Error deleting student and image: ", error);
        }
    };

    const getArticles = async () => {
        try {
            const schoolsInfo = getDocs(collection(FireStore, "school"));
            console.log("schooolfinnnfo", schoolsInfo);
            return await schoolsInfo;
        } catch (error) {
            console.error("Error in getArticles: ", error);
        }
    };

    const getStudentsBySchool = async (schoolName) => {
        try {
            const studentsCollectionRef = collection(FireStore, "school");
            const querySnapshot = await getDocs(studentsCollectionRef);
    
            const students = querySnapshot.docs
                .map((doc) => ({ id: doc.id, ...doc.data() }))
                .filter((student) => student.school === schoolName);
    
            return students;
        } catch (error) {
            console.error("Error fetching students by school:", error);
            return [];
        }
    };
    
    const uploadPhotos = async (files, category) => {
        const MAX_PHOTOS = 30; // Maximum limit for photos/videos
        try {
            const photoCollectionRef = collection(FireStore, 'photos');
            const photoDocs = await getDocs(photoCollectionRef);
    
            if (photoDocs.size + files.length > MAX_PHOTOS) {
                throw new Error(`Cannot upload more than ${MAX_PHOTOS} items.`);
            }
    
            const uploadPromises = files.map(async (file) => {
                const fileType = file.type.startsWith('image/') ? 'image' : 'video';
                
    
                const fileRef = ref(storage, `${category}/${Date.now()}-${file.name}`);
                await uploadBytes(fileRef, file);
                const fileUrl = await getDownloadURL(fileRef);
    
                return { fileUrl, fileType };
            });
    
            const uploadedFiles = await Promise.all(uploadPromises);
    
            const addDocPromises = uploadedFiles.map(({ fileUrl, fileType }) =>
                addDoc(photoCollectionRef, {
                    imageUrl: fileUrl,
                    category: category,
                    type: fileType, // Store type ('image' or 'video')
                    uploadedAt: new Date().toISOString(),
                })
            );
    
            await Promise.all(addDocPromises);
            console.log(` uploaded successfully to category: ${category}.`);
        } catch (error) {
            console.error(`Error uploading types: `, error);
        }
    };
    
    
    const displayPhotos = async (type = null) => {
        try {
            const photoCollectionRef = collection(FireStore, 'photos');
            const photoDocs = await getDocs(photoCollectionRef);
    
            return photoDocs.docs
                .map((doc) => ({ id: doc.id, ...doc.data() }))
                .filter((doc) => (type ? doc.type === type : true)); // Filter by type if specified
        } catch (error) {
            console.error('Error fetching media: ', error);
            return [];
        }
    };
    

    const deletePhoto = async (photoId) => {
        try {
            const photoRef = doc(FireStore, 'photos', photoId);
            const photoData = await getDoc(photoRef);
            
            if (photoData.exists()) {
                const imageUrl = photoData.data().imageUrl;
                const storageRef = ref(storage, imageUrl);

                await deleteObject(storageRef);
                await deleteDoc(photoRef);
                console.log('Photo deleted successfully.');
            }
        } catch (error) {
            console.error('Error deleting photo: ', error);
        }
    };

    const deleteAllPhotos = async () => {
        try {
            const photoCollectionRef = collection(FireStore, 'photos');
            const photoDocs = await getDocs(photoCollectionRef);

            const deletePromises = photoDocs.docs.map(async (doc) => {
                const photoData = doc.data();
                const imageRef = ref(storage, photoData.imageUrl);
                await deleteObject(imageRef);
                await deleteDoc(doc.ref);
            });

            await Promise.all(deletePromises);
            console.log('All photos deleted successfully.');
        } catch (error) {
            console.error('Error deleting all photos: ', error);
        }
    };

    const deleteAllPhotosInCategory = async (category) => {
        try {
            const photoCollectionRef = collection(FireStore, 'photos');
            const photoDocs = await getDocs(photoCollectionRef);
    
            const deletePromises = photoDocs.docs
                .filter(doc => doc.data().category === category)
                .map(async (doc) => {
                    const photoData = doc.data();
                    const imageRef = ref(storage, photoData.imageUrl);
                    await deleteObject(imageRef);
                    await deleteDoc(doc.ref);
                });
    
            await Promise.all(deletePromises);
            console.log(`All photos in category ${category} deleted successfully.`);
        } catch (error) {
            console.error('Error deleting all photos in category:', error);
        }
    };
    

    const getImageURL = async (path) => {
        try {
            return await getDownloadURL(ref(storage, path));
        } catch (error) {
            console.error('Error in getImageURL: ', error);
        }
    };

    const setEvents = async (city, venue, eventDate, startTime, duration, venuePic) => {
        try {
            let venuePicURL = '';
    
            // Upload venue picture to Firebase Storage if provided
            if (venuePic) {
                const imageRef = ref(storage, `events/${Date.now()}-${venuePic.name}`);
                const uploadResult = await uploadBytes(imageRef, venuePic);
                venuePicURL = await getDownloadURL(uploadResult.ref);
            }
    
            // Add event details to Firestore
            const eventDocRef = await addDoc(collection(FireStore, "events"), {
                city,
                venue,
                eventDate,         // Store the date in 'YYYY-MM-DD' format from date input
                startTime,          // Store time in 'HH:MM' format from time input
                duration,           // Store duration as a number representing hours
                venuePicURL,        // Store the download URL of the uploaded photo or empty string if no photo
                addedOn: new Date().toISOString() // Optional field to track creation date
            });
    
            console.log("Event added with ID:", eventDocRef.id);
            return eventDocRef.id;  // Return the new event's ID if needed for further use
    
        } catch (error) {
            console.error("Error in setEvents:", error);
            throw new Error("Failed to save event");
        }
    };

    const getEvents = async () => {
        try {
            const eventsCollectionRef = collection(FireStore, "events");
            const eventsSnapshot = await getDocs(eventsCollectionRef);
    
            // Map through each document to get event data and associated photo URL
            const events = await Promise.all(eventsSnapshot.docs.map(async (doc) => {
                const eventData = doc.data();
    
                // Check if there’s a venue photo URL, if so, get its actual download URL
                let venuePicURL = "";
                if (eventData.venuePicURL) {
                    const venuePicRef = ref(storage, eventData.venuePicURL);
                    venuePicURL = await getDownloadURL(venuePicRef);
                }
    
                return {
                    id: doc.id,
                    city: eventData.city,
                    venue: eventData.venue,
                    eventDate: eventData.eventDate,
                    startTime: eventData.startTime,
                    duration: eventData.duration,
                    venuePicURL: venuePicURL,
                };
            }));
    
            return events;
        } catch (error) {
            console.error("Error in getEvents:", error);
            throw new Error("Failed to fetch events");
        }
    };

    const deleteEvent = async (eventId, venuePicURL) => {
        try {
            // Delete event document from Firestore
            const eventDocRef = doc(FireStore, "events", eventId);
            await deleteDoc(eventDocRef);
            
            // Delete image from Firebase Storage if it exists
            if (venuePicURL) {
                const imageRef = ref(storage, venuePicURL);
                await deleteObject(imageRef);
            }
            
            console.log("Event and image deleted successfully.");
        } catch (error) {
            console.error("Error deleting event and image:", error);
        }
    };
    

    return (
        <FirebaseContext.Provider
            value={{
                uploadPhotos,
                deleteAllPhotos,
                deletePhoto,
                displayPhotos,
                signUpUserWithEmail,
                signInUserWithEmail,
                isLoggedIn,
                logout,
                setArticles,
                getArticles,
                getStudentsBySchool,
                getImageURL,
                deleteStudent,
                setEvents,
                getEvents,
                deleteEvent,
                deleteAllPhotosInCategory,
            }}
        >
            {props.children}
        </FirebaseContext.Provider>
    );
};
